import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Header } from '../../../../components/header';
import { NavHeader } from '../../../../components/nav-header';
import { Page } from '../../../../components/page';
import { useCalculateElapsedTime } from '../../../../hooks/notifications/use-calculate-elapsed-time';
import { ROUTES } from '../../../../routes/routes';

type NotificationDetailsCommonProps = {
  title: string;
  message: string;
  createdTimestampUTC: number;
};

const NotificationDetailsCommon: React.FC<NotificationDetailsCommonProps> = ({
  title,
  message,
  createdTimestampUTC,
}) => {
  const navigate = useNavigate();
  const { timeElepse } = useCalculateElapsedTime(createdTimestampUTC);

  const handleBack = () => navigate(ROUTES.Root());

  return (
    <Page
      isStickyHeader
      header={
        <>
          <NavHeader onClick={handleBack} />
          <Header title={title} isUnderline />
        </>
      }
    >
      <Typography className="m-b-24">{message}</Typography>
      <Typography sx={{ fontSize: 14, color: 'var(--color-type-secondary)' }}>{timeElepse}</Typography>
    </Page>
  );
};

export default NotificationDetailsCommon;
